<template>
  <div id="common-data-table">
    <v-data-table
      hide-default-footer
      :items-per-page="-1"
      class="sc-data-table"
      :headers="headers.map((header) => ({ ...header, key: header.value }))"
      :items="items"
      :sort-by="[{ key: sortBy[0], order: sortDesc[0] ? 'desc' : 'asc' }]"
    >
      <template #header.multi="{ column: header }">
        <template
          v-for="item in header.multi"
          :key="item.text"
        >
          <BaseTableHeaderMulti
            :header="item"
            :is-sort-descending="sortDesc[0]"
            :is-active="isActiveSort(item)"
            :color="isActiveSort(item) ? 'black' : 'grey'"
            @sortChangeEvent="sortChangeHandler"
          />
        </template>
      </template>
      <template #item="{ item }">
        <tr>
          <td>
            <span v-if="item.invoice_number">№{{ item.invoice_number }}</span>
            <span v-else class="record-id small"><strong>#{{ item._key }}</strong></span>
          </td>
          <td>
            <div class="small">{{ $filters.formatDate(item.invoice_date) }}</div>
          </td>
          <td>{{ $filters.formatCurrency(item.amount) }}</td>
          <td>{{ $filters.formatDate(item.due_date) }}</td>
          <td :style="`color: ${item.color}`">{{ $filters.capitalize(item.status) }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';

import { getInvoiceStatusProps } from '@/bundles/Deal/helpers';
import { IHeader } from '@/bundles/BaseTable/interfaces';

import BaseTableHeaderMulti from '@/bundles/BaseTable/components/BaseTableHeaderMulti.vue';

const headers: IHeader[] = [
  {
    multi: [{ text: 'Invoice #', sortable: true, value: 'invoice_number', icon: 'number' }],
    value: 'multi',
    sortable: false
  },
  {
    multi: [{ text: 'Invoice Date', sortable: true, value: 'invoice_date', icon: 'date' }],
    value: 'multi',
    sortable: false
  },
  {
    multi: [{ text: 'Invoice Amount', sortable: true, value: 'amount', icon: 'number' }],
    value: 'multi',
    sortable: false
  },
  {
    multi: [{ text: 'Due Date', sortable: true, value: 'due_date', icon: 'date' }],
    value: 'multi',
    sortable: false
  },
  {
    multi: [{ text: 'Status', sortable: true, value: 'status', icon: 'text' }],
    value: 'multi',
    sortable: false
  }
];

export default defineComponent({
  name: 'OpenBalancesInvoiceTable',

  components: {
    BaseTableHeaderMulti
  },

  props: {
    itemsEntry: {
      type: Array as PropType<any>,
      default: () => []
    }
  },

  data: () => ({
    headers,
    items: [],
    sortBy: ['due_date'],
    sortDesc: [true]
  }),

  mounted () {
    this.items = this.itemsEntry.map(item => {
      const { status, color } = getInvoiceStatusProps(item);
      return {
        ...item,
        status,
        color
      };
    });
  },

  methods: {
    isActiveSort: function (item: IHeader): boolean {
      return this.sortBy[0] === item.value;
    },
    sortChangeHandler (payload: { sortBy: [string]; sortDesc: [boolean] }) {
      const { sortBy, sortDesc } = payload;
      this.sortBy = sortBy;
      this.sortDesc = sortDesc;
    },
  }
})
</script>
